export enum CameraProjectionType {
    ORTHOGRAPHIC = 'orthographic',
    PERSPECTIVE = 'perspective'
}
